import catIcon from '@common/_assets/images/icon-cat.svg';
import dogIcon from '@common/_assets/images/icon-dog.svg';
import { IPhotoModel } from '@common/models';
import { ImageResizerUtil } from '@common/utils';
import classNames from 'classnames';
import { toNumber } from 'lodash';
import { observer } from 'mobx-react';
import React, { useMemo } from 'react';
import { Image } from 'react-bootstrap';
import { PhotoUtils } from './photoUtils';

export interface IPetPhotoProps {
    photo?: IPhotoModel,
    petName: string,
    speciesName?: string,
    speciesPlaceHolderOverride: string,
	makeCircularWhenPhoto?: boolean
}

export const PetPhoto = observer(({ photo, speciesName, speciesPlaceHolderOverride, petName, height, width, className, makeCircularWhenPhoto = false, ...attrs }: IPetPhotoProps & React.ImgHTMLAttributes<HTMLImageElement>) => {
	const speciesPlaceHolderImage: string | undefined = useMemo(() => speciesName === 'Canine' ? dogIcon : (speciesName === 'Feline' ? catIcon : speciesPlaceHolderOverride ? speciesPlaceHolderOverride : undefined), [speciesName, speciesPlaceHolderOverride]);
    const overrideHeight = height != undefined;
    const overrideWidth = width != undefined;
	const lHeight = toNumber(height ? height : 150);
    const lWidth = toNumber(width ? width : 150);
    const photoUrl = useMemo(() => ImageResizerUtil.getAzureImageUrlByPhoto(photo, { mode: 'pad', height: lHeight, width: lWidth }), [photo, lHeight, lWidth]);
    const imageSize = PhotoUtils.getImageSize(width, height, speciesPlaceHolderImage, photo);
	const addCircularClass = makeCircularWhenPhoto && photo && (photo.photoUrl !== "" && !_.isNil(photo.photoUrl));
	if (addCircularClass) className = classNames(className, 'circle-img');

    return (
        <>
            {(photoUrl || speciesPlaceHolderImage) &&
                <Image
					className={classNames(className)}
					src={photoUrl ? photoUrl : speciesPlaceHolderImage}
					alt={`photo of pet ${petName}`}
					height={overrideHeight ? lHeight : imageSize.height}
					width={overrideWidth ? lWidth : imageSize.width}
					{...attrs} />
            }
        </>
    )
});
